import "./src/styles/global.css"
import "intl-tel-input/build/css/intlTelInput.css";

export const onInitialClientRender = () => {
    const shouldLazy = (img) => {
        // Explicit opt-out
        if (img.dataset && img.dataset.noLazy === "true") return false;

        // If it's already specified, respect it
        if (img.getAttribute("loading")) return null;

        // Don't lazy-load images near the top (protect LCP)
        const top = img.getBoundingClientRect().top;
        if (top >= 0 && top < window.innerHeight * 1.5) return false;

        return true;
    };

    const apply = () => {
        document.querySelectorAll("img").forEach((img) => {
        const lazy = shouldLazy(img);

        if (lazy === true) img.setAttribute("loading", "lazy");
        if (lazy === false) img.setAttribute("loading", "eager");

        if (!img.getAttribute("decoding")) img.setAttribute("decoding", "async");
        });
    };

    apply();

    const mo = new MutationObserver(() => apply());
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Optional: disconnect after the initial wave of renders
    setTimeout(() => mo.disconnect(), 3000);
};
